// extracted by mini-css-extract-plugin
export default {"container":"solutionFact_container__FYVtj","fact":"solutionFact_fact__7+7wY","factContainer":"solutionFact_factContainer__t7XvL","factList":"solutionFact_factList__YbghI"};